// team.js

const teamCards = document.querySelectorAll('.team__card');

teamCards.forEach(card => {
  const video = card.querySelector('video');

  if (video) {
    card.addEventListener("mouseenter", () => {
      video.currentTime = 0;
      video.play();
    });

    card.addEventListener("mouseleave", () => {
      // Optional: pause or mute if you want
      video.pause();
      // video.currentTime = 0; // uncomment to reset again on leave if needed
    });
  }
});